import AxiosService from '../AxiosService';
import { apiUrl, isEmpty, queryString } from '../config/globals';

export const getImage = (view) => {
  let imageUrl = '/assets/images/no-image.jpg';
  if (!isEmpty(view) && view.hasOwnProperty('bannerFileView') && view.bannerFileView.hasOwnProperty('fileId')) {
    imageUrl = `${apiUrl('file')}/download-image?fileId=${view.bannerFileView.fileId}`;
  }
  if (!isEmpty(view) && view.hasOwnProperty('fileId')) {
    imageUrl = `${apiUrl('file')}/download-image?fileId=${view.fileId}`;
  }
  return imageUrl;
};

export const downloadXL = (module, data) => AxiosService.post(`${apiUrl(module, 'private')}/download-excel`, data, { responseType: 'blob' });
export const downloadMISXL = (module, data, params) => AxiosService.post(`${apiUrl(module, 'private')}/download-mis-excel?${queryString(params)}`, data, { responseType: 'blob' });
